import React, { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import PropTypes from 'prop-types';

const OptionTileModal = ({ isOpen, onClose, title, options, handleOptionClick , saveLabel, handleSaveClick, additionalComponent  }) => {
  
  return (
    <>
      <Modal contentWidth="750px" isOpen={isOpen} titleName={title} onClose={onClose}>
        <div className="d-flex align-items-center justify-content-around printing-options-wrapper mb-5">
          {options.map((item) => {
            return (
              <div
                key={item.id}
                className={`printing-options cursor-pointer ${item.isActive ? 'active' : ''}`}
                id={item.id}
                onClick={handleOptionClick}>
                {item.icon}
                <h5>{item.label}</h5>
              </div>
            );
          })}
        </div>
        {additionalComponent && additionalComponent}
        { !(isOpen && additionalComponent) && <div className="d-flex justify-content-end gap-3 align-items-center">
          <button className="btn btn-castleGray option-btn" onClick={onClose}>
          Cancel
          </button>
          <button className="btn btn-castleRed option-btn" onClick={handleSaveClick}>
            {saveLabel}
          </button>        
        </div>  
        }      
      </Modal>    
    </>
  );
};

OptionTileModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  additionalComponent: PropTypes.element
};

export default OptionTileModal;
